import React from 'react'
import CountriesState from './Charts/CountriesState'
import Doughnut from './Charts/Doughnut'
import "./style.css"
import TotalAssets from './Charts/totalAssets'
import SalesStats from './Charts/SalesStats'
import HeaderName from '../../components/HeaderName'
import { useTranslation } from 'react-i18next'
import ActionBtn from '@/components/ActionBtn'
import { useNavigate } from 'react-router-dom'
const ColorPallete = [{ id: 1, color: '#FE4D22' }, { id: 2, color: '#FFE14D' }, { id: 3, color: '#FF9A35' }, { id: 4, color: '#98A2B2' }, { id: 5, color: "#4E4E4E" }]

const HomePage = () => {

    const { t } = useTranslation()
    const navigate = useNavigate()

    return (

        <>
            <HeaderName PageName={t("Home")} />
            <ActionBtn  className='submit-btn' title='edit-profile' onApply={() => navigate('/panel/provider-profile')  }/>
        </>
    )
}

export default HomePage